import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import { useState } from "react";
import LoginPage from "./LoginPage";

const GREEN = "#00C853";
const DARK = "#0D1420";
const WHITE = "#FFFFFF";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

const fadeIn = (delay = 0) => ({
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  transition: { duration: 0.6, delay },
  viewport: { once: true },
});

export default function LandingPage() {
  const [openLogin, setOpenLogin] = useState(false);

  return (
    <Box sx={{ bgcolor: WHITE, minHeight: "100vh", fontFamily: "'Outfit', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700;800;900&display=swap');`}</style>

      {/* NAVBAR */}
      <Box sx={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        bgcolor: WHITE,
        borderBottom: "1px solid #f0f0f0",
        px: { xs: 3, md: 8 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
        {/* Isotipo siempre izquierda */}
        <img src="/assets/icons/logo.png" alt="P" style={{ height: 90 }} />

        {/* Logo centrado - solo desktop */}
        <Box sx={{
          display: { xs: "none", md: "flex" },
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
        }}>
          <img src="/assets/icons/logo.png" alt="Prestiya" style={{ height: 90 }} />
        </Box>

        {/* Botón derecha */}
        <Button
          variant="contained"
          onClick={() => setOpenLogin(true)}
          sx={{
            bgcolor: GREEN,
            color: WHITE,
            fontFamily: "Outfit",
            fontWeight: 700,
            fontSize: { xs: 13, md: 15 },
            borderRadius: "50px",
            px: { xs: 2, md: 3 },
            py: 1.2,
            textTransform: "none",
            boxShadow: "none",
            "&:hover": { bgcolor: "#00b048", boxShadow: "none" },
          }}
        >
          Solicitar préstamo
        </Button>
      </Box>

      {/* HERO */}
      <Box sx={{ bgcolor: DARK, minHeight: { xs: "90vh", md: "85vh" }, display: "flex", alignItems: "center", position: "relative", overflow: "hidden", px: { xs: 3, md: 10 } }}>
        <Box sx={{ position: "absolute", right: { xs: -100, md: -50 }, top: "50%", transform: "translateY(-50%)", width: { xs: 300, md: 600 }, height: { xs: 300, md: 600 }, borderRadius: "50%", border: `2px solid ${GREEN}22`, pointerEvents: "none" }} />
        <Box sx={{ position: "absolute", right: { xs: -60, md: 30 }, top: "50%", transform: "translateY(-50%)", width: { xs: 200, md: 400 }, height: { xs: 200, md: 400 }, borderRadius: "50%", bgcolor: `${GREEN}11`, pointerEvents: "none" }} />
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={7}>
              <motion.div {...fadeUp(0)}>
                <Box sx={{ display: "inline-block", bgcolor: `${GREEN}22`, border: `1px solid ${GREEN}44`, borderRadius: "50px", px: 2, py: 0.5, mb: 3, mt: { xs: 5, md: 0 } }}>
                  <Typography sx={{ color: GREEN, fontFamily: "Outfit", fontWeight: 600, fontSize: 13, letterSpacing: 1, textTransform: "uppercase" }}>✦ Crédito simple. Crecimiento real.</Typography>
                </Box>
              </motion.div>
              <motion.div {...fadeUp(0.1)}>
                <Typography sx={{ fontFamily: "Outfit", fontWeight: 900, fontSize: { xs: 42, md: 68 }, color: WHITE, lineHeight: 1.1, mb: 3 }}>
                  Tu préstamo{" "}<Box component="span" sx={{ color: GREEN }}>rápido</Box>{" "}y sin complicaciones
                </Typography>
              </motion.div>
              <motion.div {...fadeUp(0.2)}>
                <Typography sx={{ fontFamily: "Outfit", fontSize: { xs: 16, md: 18 }, color: "#8899AA", mb: 4, maxWidth: 500, lineHeight: 1.7 }}>
                  Desde <strong style={{ color: WHITE }}>$100.000 COP</strong> hasta{" "}<strong style={{ color: WHITE }}>$3.000.000 COP</strong> con cuotas mensuales. Proceso 100% digital, desembolso el mismo día.
                </Typography>
              </motion.div>
              <motion.div {...fadeUp(0.3)}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <Button size="large" variant="contained" onClick={() => setOpenLogin(true)} sx={{ bgcolor: GREEN, color: WHITE, fontFamily: "Outfit", fontWeight: 700, fontSize: 16, borderRadius: "50px", px: 4, py: 1.8, textTransform: "none", boxShadow: `0 0 30px ${GREEN}44`, "&:hover": { bgcolor: "#00b048" } }}>
                    Solicitar ahora →
                  </Button>
                  <Button size="large" variant="outlined" href="#como-funciona" sx={{ color: WHITE, borderColor: "#ffffff33", fontFamily: "Outfit", fontWeight: 600, fontSize: 16, borderRadius: "50px", px: 4, py: 1.8, textTransform: "none", "&:hover": { borderColor: GREEN, color: GREEN } }}>
                    ¿Cómo funciona?
                  </Button>
                </Stack>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={5}>
              <motion.div {...fadeUp(0.4)}>
                <Grid container spacing={2}>
                  {[
                    { value: "$3M", label: "Monto máx. COP" },
                    { value: "1 día", label: "Desembolso" },
                    { value: "100%", label: "Digital" },
                    { value: "Fácil", label: "Sin trámites" },
                  ].map((stat) => (
                    <Grid item xs={6} key={stat.label}>
                      <Box sx={{ bgcolor: "#ffffff08", border: "1px solid #ffffff11", borderRadius: 3, p: 3, textAlign: "center", minHeight: 110, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <Typography sx={{ fontFamily: "Outfit", fontWeight: 800, fontSize: 32, color: GREEN, lineHeight: 1 }}>{stat.value}</Typography>
                        <Typography sx={{ fontFamily: "Outfit", fontSize: 13, color: "#8899AA", mt: 0.5 }}>{stat.label}</Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* CÓMO FUNCIONA */}
      <Box id="como-funciona" sx={{ bgcolor: "#F7F9F7", py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <motion.div {...fadeIn(0)}>
            <Typography sx={{ fontFamily: "Outfit", fontWeight: 800, fontSize: { xs: 32, md: 46 }, color: DARK, textAlign: "center", mb: 1 }}>¿Cómo funciona?</Typography>
            <Typography sx={{ fontFamily: "Outfit", fontSize: 17, color: "#667788", textAlign: "center", mb: 8 }}>En 3 pasos simples tenés tu dinero</Typography>
          </motion.div>
          <Grid container spacing={4}>
            {[
              { num: "01", title: "Registrate y verificate", desc: "Creá tu cuenta con tu número de WhatsApp y subí foto de tu documento. Verificamos tu identidad en minutos." },
              { num: "02", title: "Solicitá tu crédito", desc: "Elegí el monto, el plazo y el propósito. Llenás tu información bancaria y enviás la solicitud." },
              { num: "03", title: "Recibí tu dinero", desc: "Firmás el pagaré digital, lo subís y hacemos el desembolso directamente a tu cuenta el mismo día." },
            ].map((step, idx) => (
              <Grid item xs={12} md={4} key={step.num}>
                <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: idx * 0.15 }} viewport={{ once: true }}>
                  <Box sx={{ bgcolor: WHITE, borderRadius: 4, p: 4, height: "100%", border: "1px solid #E8F0E8", "&:hover": { borderColor: GREEN, boxShadow: `0 8px 40px ${GREEN}18`, transform: "translateY(-4px)" }, transition: "all 0.3s ease" }}>
                    <Typography sx={{ fontFamily: "Outfit", fontWeight: 900, fontSize: 64, color: `${GREEN}22`, lineHeight: 1, mb: 2 }}>{step.num}</Typography>
                    <Typography sx={{ fontFamily: "Outfit", fontWeight: 700, fontSize: 20, color: DARK, mb: 1.5 }}>{step.title}</Typography>
                    <Typography sx={{ fontFamily: "Outfit", fontSize: 15, color: "#667788", lineHeight: 1.7 }}>{step.desc}</Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* BENEFICIOS */}
      <Box sx={{ bgcolor: WHITE, py: { xs: 8, md: 12 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <motion.div {...fadeIn(0)}>
                <Typography sx={{ fontFamily: "Outfit", fontWeight: 800, fontSize: { xs: 32, md: 46 }, color: DARK, mb: 2, lineHeight: 1.1 }}>
                  Simple, rápido y{" "}<Box component="span" sx={{ color: GREEN }}>confiable</Box>
                </Typography>
                <Typography sx={{ fontFamily: "Outfit", fontSize: 16, color: "#667788", mb: 4, lineHeight: 1.7 }}>
                  Prestiya es tecnología financiera pensada para colombianos que necesitan acceso rápido a crédito sin trámites engorrosos.
                </Typography>
                <Stack spacing={2}>
                  {["Aprobación en minutos", "Sin codeudores obligatorios", "Cuotas mensuales fijas", "Atención por WhatsApp", "Proceso 100% digital", "Información protegida y cifrada"].map((benefit) => (
                    <Stack key={benefit} direction="row" spacing={1.5} alignItems="center">
                      <Box sx={{ width: 22, height: 22, borderRadius: "50%", bgcolor: `${GREEN}22`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: GREEN }} />
                      </Box>
                      <Typography sx={{ fontFamily: "Outfit", fontSize: 16, color: DARK }}>{benefit}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={6}>
              <motion.div {...fadeIn(0.2)}>
                <Box sx={{ bgcolor: DARK, borderRadius: 4, p: 4, position: "relative", overflow: "hidden" }}>
                  <Box sx={{ position: "absolute", top: -40, right: -40, width: 200, height: 200, borderRadius: "50%", bgcolor: `${GREEN}11` }} />
                  <Typography sx={{ fontFamily: "Outfit", fontWeight: 700, fontSize: 18, color: GREEN, mb: 3 }}>Simulador de crédito</Typography>
                  {[
                    { label: "Monto", value: "$1.000.000 COP" },
                    { label: "Plazo", value: "6 meses" },
                    { label: "Tasa mensual", value: "Según perfil" },
                    { label: "Cuota mensual aprox.", value: "Consultar" },
                    { label: "Total a pagar", value: "A convenir" },
                  ].map((row, idx) => (
                    <Box key={row.label} sx={{ display: "flex", justifyContent: "space-between", py: 1.5, borderBottom: idx < 4 ? "1px solid #ffffff11" : "none" }}>
                      <Typography sx={{ fontFamily: "Outfit", fontSize: 14, color: "#8899AA" }}>{row.label}</Typography>
                      <Typography sx={{ fontFamily: "Outfit", fontWeight: 700, fontSize: 14, color: idx === 4 ? GREEN : WHITE }}>{row.value}</Typography>
                    </Box>
                  ))}
                  <Button fullWidth variant="contained" onClick={() => setOpenLogin(true)} sx={{ mt: 3, bgcolor: GREEN, color: WHITE, fontFamily: "Outfit", fontWeight: 700, borderRadius: "50px", py: 1.5, textTransform: "none", fontSize: 15, boxShadow: "none", "&:hover": { bgcolor: "#00b048" } }}>
                    Quiero este crédito
                  </Button>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* CTA FINAL */}
      <Box sx={{ bgcolor: DARK, py: { xs: 10, md: 14 }, textAlign: "center", position: "relative", overflow: "hidden" }}>
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 600, height: 600, borderRadius: "50%", bgcolor: `${GREEN}08`, pointerEvents: "none" }} />
        <Container maxWidth="sm">
          <motion.div {...fadeIn(0)}>
            <Typography sx={{ fontFamily: "Outfit", fontWeight: 900, fontSize: { xs: 36, md: 52 }, color: WHITE, mb: 2, lineHeight: 1.1 }}>
              Accede a tu{" "}<Box component="span" sx={{ color: GREEN }}>crédito</Box>{" "}hoy mismo
            </Typography>
            <Typography sx={{ fontFamily: "Outfit", fontSize: 17, color: "#8899AA", mb: 5 }}>Registrate gratis y solicitá tu crédito de manera rápida y segura.</Typography>
            <Button size="large" variant="contained" onClick={() => setOpenLogin(true)} sx={{ bgcolor: GREEN, color: WHITE, fontFamily: "Outfit", fontWeight: 700, fontSize: 17, borderRadius: "50px", px: 6, py: 2, textTransform: "none", boxShadow: `0 0 40px ${GREEN}44`, "&:hover": { bgcolor: "#00b048" } }}>
              Solicitar préstamo →
            </Button>
          </motion.div>
        </Container>
      </Box>

      {/* FOOTER */}
      <Box sx={{ bgcolor: "#080E18", py: 4, textAlign: "center" }}>
        <Stack direction="row" spacing={3} justifyContent="center" sx={{ mb: 2 }}>
          <Link href="/privacidad" underline="hover" sx={{ color: "#667788", fontFamily: "Outfit", fontSize: 13 }}>Política de Privacidad</Link>
          <Link href="/tratamiento-datos" underline="hover" sx={{ color: "#667788", fontFamily: "Outfit", fontSize: 13 }}>Tratamiento de Datos</Link>
        </Stack>
        <Typography sx={{ fontFamily: "Outfit", fontSize: 13, color: "#445566" }}>© {new Date().getFullYear()} Prestiya. Todos los derechos reservados.</Typography>
      </Box>

      {/* LOGIN DIALOG */}
      <Dialog fullWidth maxWidth="xs" open={openLogin} onClose={() => setOpenLogin(false)}>
        <IconButton onClick={() => setOpenLogin(false)} sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}>
          <CloseIcon />
        </IconButton>
        <Box sx={{ p: 1 }}>
          <LoginPage />
        </Box>
      </Dialog>
    </Box>
  );
}
